document.querySelectorAll('.fg-tsp').forEach(function (root) {
  var btn = root.querySelector('.fg-tsp__btn');
  if (!btn) return;

  var variantId = root.getAttribute('data-trial-variant-id');
  var discountCode = root.getAttribute('data-trial-discount-code');

  btn.addEventListener('click', function (event) {
    var fallback = btn.getAttribute('href');

    if (!fallback || fallback === '#') {
      event.preventDefault();
      return;
    }

    if (!variantId || !discountCode) return;

    event.preventDefault();
    btn.style.pointerEvents = 'none';

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        window.location.href = '/discount/' + discountCode + '?redirect=/checkout';
      })
      .catch(function () {
        window.location.href = fallback;
      });
  });
});
